export default "__VITE_ASSET__fAxClDuj__"